import { useLocation } from 'react-router-dom'
import classNames from 'classnames'

import { Menu } from 'client/semantic-imports'
import { useAppContext, usePage, usePageStateContext } from 'client/hooks'
import { getAccountStatus } from 'client/services'
import { FormName } from 'client/utils'

import TopBarMobile from './top-bar-mobile'
import TopBarDesktop from './top-bar-desktop'

import styles from './top-bar.module.scss'
import './top-bar.scss'

const TopBar = () => {
  const { pathname, search } = useLocation()

  const { navigateTo } = usePage()
  const { authUser, showAppNotifications, setShowAppNotifications } = useAppContext()
  const { setRedirectQuestionId, setAuthForm } = usePageStateContext()

  const accountStatus = getAccountStatus(authUser)

  const getOnClickHandler = (path: string, action?: string) => {
    if (path === '/auth' && pathname === '/question') {
      setRedirectQuestionId(search.split('=')[1])
    }
    return () => {
      if (showAppNotifications) {
        setShowAppNotifications(false)
      }

      if (path === '/auth' && action) {
        setAuthForm(action as FormName)
      }
      navigateTo({
        path,
        query: path === '/profile' ? { _id: authUser._id.toString() } : null,
      })
    }
  }

  return (
    <div className={classNames('appTopBar', styles.topBarContainer)}>
      <div className={styles.mobile}>
        <Menu inverted borderless fluid className={styles.topBar}>
          <TopBarMobile
            accountStatus={accountStatus}
            getOnClickHandler={getOnClickHandler}
          />
        </Menu>
      </div>
      <div className={styles.desktop}>
        <Menu inverted borderless fluid className={styles.topBar}>
          <TopBarDesktop
            accountStatus={accountStatus}
            getOnClickHandler={getOnClickHandler}
          />
        </Menu>
      </div>
    </div>
  )
}

export default TopBar
